import {signIn as types} from '../actions/actiontypes'
import formReducer from './formReducer'

const signInReducer = formReducer(types)

export {signInReducer}
